import { supabase } from "./supabaseClient";

// Every niche with its sub-groups, A-Z.
export async function fetchNiches() {
  const { data, error } = await supabase
    .from("niches")
    .select("id, name, synonyms, active, sub_groups(id, name, trigger_words)")
    .order("name");
  if (error) console.error("fetchNiches", error);
  return data || [];
}

// Saves a niche the user typed that we don't have yet. Returns its id or null.
export async function saveNicheSuggestion({ agencyId, userId, text }) {
  const { data, error } = await supabase
    .from("niche_suggestions")
    .insert({ agency_id: agencyId, user_id: userId, typed_text: text })
    .select("id")
    .single();
  if (error) console.error("saveNicheSuggestion", error);
  return data ? data.id : null;
}

// Your past scans of these keywords, any niche, any location (for the data dots).
export async function fetchKeywordHistory({ standardForms, userId }) {
  if (!standardForms.length || !userId) return [];
  const { data, error } = await supabase
    .from("keywords")
    .select("standard_form, job_id, jobs!inner(created_by, started_at)")
    .in("standard_form", standardForms)
    .eq("jobs.created_by", userId);
  if (error) console.error("fetchKeywordHistory", error);
  return data || [];
}

// How many scans you've run in this niche, and the keywords of the latest.
export async function fetchNicheJobs({ nicheId, userId }) {
  if (!nicheId || !userId) return { count: 0, latestKeywords: [] };
  const { data, count, error } = await supabase
    .from("jobs")
    .select("id, keywords, started_at", { count: "exact" })
    .eq("niche_id", nicheId)
    .eq("created_by", userId)
    .order("started_at", { ascending: false })
    .limit(1);
  if (error) console.error("fetchNicheJobs", error);
  return { count: count || 0, latestKeywords: data && data[0] ? data[0].keywords || [] : [] };
}
